module.exports = __webpack_public_path__ + "img/limit_10-13.7e9cb51e.png";